var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "usersListContainer", staticClass: "container mb-5" },
    [
      _c("div", { staticClass: "k-tabs" }, [
        _c("ul", { staticClass: "k-tabs__list" }, [
          _c("li", { staticClass: "k-tabs__item k-tabs__item--active" }, [
            _c(
              "span",
              { staticClass: "k-tabs__link k-tabs__list--nohover" },
              [_vm._t("default")],
              2
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "k-tabs__sorting" }, [
          _c("span", { staticClass: "k-tabs__sorting-text" }, [
            _vm._v("Řadit podle:")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.orderBy,
                  expression: "orderBy"
                }
              ],
              ref: "sortSelect1",
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.orderBy = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.sortChanged
                ]
              }
            },
            [
              _c("option", { attrs: { value: "name" } }, [_vm._v("Jména")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "branch" } }, [_vm._v("Pobočky")])
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.orderDirection,
                  expression: "orderDirection"
                }
              ],
              ref: "sortSelect2",
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.orderDirection = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.sortChanged
                ]
              }
            },
            [
              _c("option", { attrs: { value: "asc" } }, [_vm._v("Vzestupně")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "desc" } }, [_vm._v("Sestupně")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        { staticClass: "row", attrs: { name: "list-complete", tag: "div" } },
        [
          _vm._l(_vm.users.data, function(user) {
            return _c("div", { key: user.id, staticClass: "col-3 k-mb-30" }, [
              _c("div", { staticClass: "k-panel k-panel--equal-height" }, [
                _c("div", { staticClass: "k-panel__body p-0 text-center" }, [
                  _c("div", { staticClass: "k-user" }, [
                    _c("div", { staticClass: "k-user__image" }, [
                      _c("img", {
                        staticClass: "k-user__image-el",
                        attrs: { src: user.prev_url }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "k-user__name",
                        attrs: { href: user.detail_url }
                      },
                      [
                        _c("h3", { staticClass: "k-h-tertiary" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(user.name) +
                              "\n                                "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "k-user__info" }, [
                      user.phone
                        ? _c("div", [_vm._v(_vm._s(user.phone))])
                        : _vm._e(),
                      _vm._v(" "),
                      user.branch_office
                        ? _c("div", [_vm._v(_vm._s(user.branch_office))])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "k-panel__footer" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "k-action k-action--control k-panel__footer-btn text-center",
                      attrs: { href: user.detail_url }
                    },
                    [_vm._v("Profil")]
                  ),
                  _vm._v(" "),
                  user.edit_url
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "k-action k-action--control text-center k-panel__footer-btn k-panel__footer-btn--bl",
                          attrs: { href: user.edit_url }
                        },
                        [_vm._v("Upravit")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          }),
          _vm._v(" "),
          _vm.users.data && _vm.users.data.length === 0
            ? _c("div", { key: 0, staticClass: "col-12" }, [
                _c("div", { staticClass: "k-panel" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "k-panel__body p-3 justify-content-center text-center"
                    },
                    [
                      _vm._v(
                        "\n                        Nebyl nalezen žádný uživatel.\n                    "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("pagination", {
        attrs: { data: _vm.users },
        on: { "pagination-change-page": _vm.paginate }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }